module.exports = __webpack_public_path__ + "fonts/ubuntu-ruble-italic.f5747cd.woff";